import React from 'react';
import { Success } from 'e4shared';
import { useDispatch, useSelector } from 'react-redux';
import { withRouter } from 'react-router-dom';

import { setMultiColumn } from 'actions/ui';
import AsideRight from 'components/asideRight';
import Feedback from 'components/asideRight/components/feedback';
import DebugHelper from 'components/debugHelper';
import Menu from 'components/prism/menu';

export const Prism = ({ history, children, setShowSuccess }) => {
    const dispatch = useDispatch();
    const { leftAsideOpen, exploreAsideOpen, filterAsideOpen, rightAsideOpen } = useSelector(state => state.ui);
    const [sideStyle, setSideStyle] = React.useState('');
    const loaded = React.useRef(null);

    const checkColumns = () => {
        if (loaded?.current) {
            const width = loaded.current.clientWidth;
            dispatch(setMultiColumn(width > 800));
        }
    };

    React.useEffect(() => {
        window.addEventListener('resize', checkColumns);

        return () => {
            window.removeEventListener('resize', checkColumns);
        };
    }, []);

    React.useEffect(() => {
        if (loaded?.current) {
            checkColumns();
        }
    }, [loaded?.current, exploreAsideOpen]);

    React.useEffect(() => {
        if (exploreAsideOpen || filterAsideOpen) {
            setSideStyle('wide');
        }

        if (rightAsideOpen) {
            setSideStyle('');
        }
    }, [exploreAsideOpen, filterAsideOpen, rightAsideOpen]);

    return (
        <>
            <Feedback />
            <DebugHelper />
            <Success setShowSuccess={setShowSuccess} />
            {/* Desktop Collapse */}
            <input
                type="checkbox"
                id="collapse-toggle"
                checked={!leftAsideOpen}
                onChange={() => {
                    console.log('Toggled');
                }}
            />

            {/* Mobile Slide-Out */}
            <input type="checkbox" id="mobile-toggle" />

            {/* signout panel */}
            <input type="checkbox" id="signout-toggle" />

            {/* Mobile Hamburger */}
            <label htmlFor="mobile-toggle" className="hamburger">
                <i className="fa fa-bars"></i>
            </label>

            <div className="app">
                {filterAsideOpen && <div className="content-overlay" />}
                {exploreAsideOpen && <div className="explore-open" />}
                <Menu />
                {/* BACKDROP (Mobile) */}
                <label className="backdrop" htmlFor="mobile-toggle"></label>

                {/* MAIN CONTENT */}
                <main id="root" className="main" ref={loaded}>
                    {/* <div className="card">
                        Above you can see 2 header layouts. One for home, the other for any page with a back.
                        <br />
                        <br />
                        This is where the main content goes?
                    </div> */}
                    {children}
                </main>
            </div>
            <AsideRight sideStyle={sideStyle} />
        </>
    );
};

export default withRouter(Prism);
